module.exports = [
    {
        type: 'pending_tasks',
        message: 'Pending Tasks',
        category: 'all',
    },
    {
        type: 'new_offer',
        message: 'New Offer',
        category: 'shipments',
    },
    {
        type: 'offer_received',
        message: 'Offer Received',
        category: 'shipments',
    },
    {
        type: 'new_shipment_assigned',
        message: 'New Shipment Assigned',
        category: 'shipments',
    },
    {
        type: 'offer_canceled',
        message: 'Offer Canceled',
        category: 'shipments',
    },
    {
        type: 'offer_accepted',
        message: 'Offer Accepted',
        category: 'shipments',
    },
    {
        type: 'picked_up_shipment',
        message: 'Picked Up Shipment',
        category: 'shipments',
    },
    {
        type: 'delivered',
        message: 'Delivered',
        category: 'shipments',
    },
    {
        type: 'bol_reminder',
        message: 'POD Upload Reminder',
        category: 'shipments',
    },
    {
        type: 'job_complete',
        message: 'Job Complete',
        category: 'shipments',
    },
    {
        type: 'job_canceled',
        message: 'Shipment Canceled',
        category: 'shipments',
    },
    {
        type: 'wait_time_warning',
        message: 'Wait Time Warning',
        category: 'shipments',
    },
    {
        type: 'shipper_batch_invoice',
        message: 'Weekly Batch Invoice',
        category: 'billing',
    },
    {
        type: 'shipper_batch_receipt',
        message: 'Weekly Batch Receipt',
        category: 'billing',
    },
    {
        type: 'card_declined',
        message: 'Card Declined',
        category: 'billing',
    },
    {
        type: 'carrier_batch_payout',
        message: 'Weekly Batch Payout',
        category: 'billing',
    },
    {
        type: 'bill_of_lading_contacts',
        message: 'Bill of Lading Contacts',
        category: 'shipments',
    },
    {
        type: 'rate_confirmation_contacts',
        message: 'Rate Confirmation',
        category: 'shipments',
    },
    {
        type: 'drayage_new_shipment_assigned',
        message: 'New Shipment Assigned',
        category: 'drayage',
    },
    {
        type: 'drayage_do_cancellation',
        message: 'DO Cancellation',
        category: 'drayage',
    },
    {
        type: 'drayage_empty_ready_pickup',
        message: 'Empty Ready Pickup for Contacts',
        category: 'drayage',
    },
    {
        type: 'drayage_new_shipment_offered',
        message: 'New Shipment Offered',
        category: 'drayage',
    },
    {
        type: 'drayage_shipper_batch_invoice',
        message: 'Invoice Contacts',
        category: 'drayage',
    },
    {
        type: 'drayage_delivery_order_contacts',
        message: 'Delivery Order Contacts',
        category: 'drayage',
    },
    {
        type: 'drayage_accessorial_requests',
        message: 'Accessorial Requests',
        category: 'drayage',
    },
    {
        type: 'drayage_wait_time_warning',
        message: 'Wait Time Warning',
        category: 'drayage',
    },
    {
        type: 'drayage_missing_documentation_contacts',
        message: 'Missing Documentation Contacts',
        category: 'drayage',
    },
    {
        type: 'drayage_shipper_batch_receipt',
        message: 'Weekly Batch Receipt',
        category: 'drayage',
    },
    {
        type: 'drayage_carrier_batch_payout',
        message: 'Weekly Batch Payout',
        category: 'drayage',
    },
    {
        type: 'drayage_card_declined',
        message: 'Card Declined',
        category: 'drayage',
    },
    {
        type: 'new_request',
        message: 'New Appointment',
        category: 'appointment',
    },
    {
        type: 'status_changed',
        message: 'Appointment Status Change',
        category: 'appointment',
    },
    {
        type: 'new_comment',
        message: 'New Appointment Comment',
        category: 'appointment',
    },
    {
        type: 'drayage_proof_of_delivery',
        message: 'Proof of Delivery',
        category: 'drayage',
    },
    {
        type: 'drayage_rate_card',
        message: 'Drayage Rate Card',
        category: 'drayage',
    },
];
